module.exports = __webpack_public_path__ + "img/icon_aside_ppt2_hover.fcc63cda.svg";